import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { isRawAsset } from '@cld/console-apps-types';

import { Content } from './Content';
import { Header } from './Header';
import { Navigable } from './Navigable';

const Layout = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
`;

export const Preview = ({ canNavigateToNext, canNavigateToPrevious, onClose, onNext, onPrevious, previewedAsset }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'ArrowLeft') {
        onPrevious();
      } else if (event.key === 'ArrowRight') {
        onNext();
      } else if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, onNext, onPrevious]);

  if (!previewedAsset) {
    return null;
  }

  return (
    <Layout>
      <Header asset={previewedAsset} onClose={onClose} />

      <Navigable
        canNavigateToNext={canNavigateToNext}
        canNavigateToPrevious={canNavigateToPrevious}
        onNext={onNext}
        onPrevious={onPrevious}
        color={isRawAsset(previewedAsset) ? 'gray40' : 'black'}
      >
        <Content asset={previewedAsset} />
      </Navigable>
    </Layout>
  );
};

Preview.propTypes = {
  canNavigateToNext: PropTypes.bool.isRequired,
  canNavigateToPrevious: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
};
